import { report } from './dataReporting';
import { getCookie } from './cookie';
import {
  setGuid,
  setVplatForm,
  setVideoAppid,
  setLangCode,
  AstroSaveCookie,
} from './util';

// 应用启动上报
export function appLaunchReport() {
  if (!getCookie('StartTime')) {
    // 首次进来重载页面,加reload会导致下方的两个上报报不上去
    // location.reload();
    // 应用启动上报
    report(
      {
        attaId: '0f500063503',
      },
      true,
    );
    // id末位为3503的多上报到09500070656
    report(
      {
        attaId: '09500070656',
      },
      true,
    );
  }
};

// cookie值初始化，添加guid、vplatform、video_appid、lang_code等信息
export function initCookieValue() {
  const plat = (document.domain === 'tv.iflix.com' || document.domain === 'test.iflix.com') ? 'iflix' : 'wetv';
  setGuid();
  setVplatForm(plat);
  setVideoAppid(plat);
  setLangCode();
  AstroSaveCookie();
}

export function defaultSetting() {
  // 默认设置
  if (!localStorage.getItem('ratio')) {
    localStorage.setItem('ratio', '0');
  }
  if (!localStorage.getItem('definition')) {
    localStorage.setItem('definition', 'shd');
  }
  if (!localStorage.getItem('skipOver')) {
    localStorage.setItem('skipOver', '2');
  }
  if (!localStorage.getItem('id')) {
    localStorage.setItem('id', '1491988');
  }
}
